// css =>
import "../../BaseStructure.css";
import Styled from "./menu.module.css";

// icons =>
import OptionIcon from "../../assets/icons/menu-option-icon.png";
import SupportIcon from "../../assets/icons/menu-support-icon.png";

// Desktop icons =>
import MoonIcon from "../../assets/icons/moon-icon.png";
import ChnageLangIcon from "../../assets/icons/change-lag-icon.png";

// componenets =>
import MobileSunMenu from "../mobile-sub-menu/mobile-sub-menu.comp";

// react =>
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// language =>
import { getTranslation } from '../../i18n/get-translation';
import { useLanguage } from '../../context/language-context';

// context =>
import { useTheme } from '../../context/theme-context';

const Menu = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();

    const t = (key) => getTranslation(language, key);
    const { language, changeLanguage } = useLanguage();

    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

    const handleMenuClick = (targetKey) => {
        if (location.pathname === '/') {
            setTimeout(() => {
                props.onScrollTo(targetKey);
            }, 250);
        } else {
            navigate('/', { state: { scrollTo: targetKey } });
        }
    };

    return (
        <>
            <div className={`row ${ Styled.mobile_menu_box } `}
                style={{
                    backgroundColor: theme === "day" ? "#778066" : "",
                    borderBottom: theme === "day" ? "3px solid #474D3D" : ""
                }}
            >
                <div className="col-4">
                    <img
                        alt="Option"
                        src={ OptionIcon }
                        className={ Styled.OptionIconBox }
                        style={{ float: "right", marginRight: "36px" }}
                        onClick={() => { setIsSubMenuOpen(isSubMenuOpen ? false : true) }}
                    />
                </div>
                <div className="col-4">
                    <h1>{ t('companyName') }</h1>
                </div>
                <div className="col-4">
                    <img src={ SupportIcon } alt="Support" />
                </div>
            </div>

            <div
                className={`row ${ Styled.desktop_menu_box } `}
                style={{
                    backgroundColor: theme === "day" ? "#778066" : "",
                    borderBottom: theme === "day" ? "5px solid #474D3D" : "",
                    float: 'left'
                }}>
                <div className="col-7"
                    style={{
                        float: language === "fa" ? "left" : "right",
                        textAlign: 'left'
                    }}>
                    <p 
                        onClick={() => handleMenuClick('services')}
                    >{ t('services') }</p>
                    <p
                        onClick={() => navigate("/products")}
                    >{ t('plants') }</p>
                    <p
                        onClick={() => navigate("/portfolio")}
                    >{ t('projects') }</p>
                    <p 
                        onClick={() => handleMenuClick('about')}
                    >{ t('aboutUs') }</p>
                    <p 
                        style={{ marginRight: '0' }}
                        onClick={() => handleMenuClick('contact')}
                    >{ t('contactUs') }</p>
                </div>

                <div 
                    className="col-3"
                    style={{
                        float: language === "fa" ? "left" : "right"
                    }}>
                    <img
                        alt="تغییر زبان"
                        src={ ChnageLangIcon }
                        onClick={() => changeLanguage(language === 'fa' ? 'en' : 'fa')}
                    />
                    <img
                        alt="پشتیبانی"
                        src={ SupportIcon }
                        onClick={() => handleMenuClick('contact')}
                    />
                    <img
                        src={MoonIcon}
                        alt='تغییر تم'
                        onClick={(e) => {
                            toggleTheme();
                        }}
                    />
                </div>
                <div className="col-2">
                    <h1>{ t('companyName') }</h1>
                </div>
            </div>

            <MobileSunMenu
                isOpen={ isSubMenuOpen }
                onScrollTo={ props.onScrollTo }
                closeMenu={() => setIsSubMenuOpen(false)}
            />
        </>
    );
}

export default Menu;
